<div class="mx-auto w-full max-w-2xl">
	<div class="flex-justify-center overflow-x-hidden rounded-lg bg-white">
		<uikit-alert
			[color]="'warning'"
			[titre]="title"
			[subtitle]="'Le conventionnement est nécessaire avant une télétransmission. '"
			[button1]="'Signer la convention'"
			(action)="signConvention()"
		></uikit-alert>
		<div class="row mt-4 flex justify-end gap-3">
			<uikit-button
				[type]="'tonal'"
				size="large"
				(click)="onCancel()"
				>Annuler</uikit-button
			>
			<uikit-button
				[type]="'tonal'"
				size="large"
				(click)="alreadySigned()"
				>J'ai déjà signé la convention {{ isInterAmc ? " avec l'inter-AMC" : "" }}
			</uikit-button>
		</div>
	</div>
	<uikit-button
		[type]="'tonal'"
		[size]="'large'"
		[radius]="'full'"
		[icon]="'times'"
		class="fixed right-[30px] top-[30px]"
		(click)="onCancel()"
	>
	</uikit-button>
</div>
